// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cell-wrapper[data-v-18a4c433] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.edit-container[data-v-18a4c433] {\n  padding: 0px 10px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
